import CryptoJS from 'crypto-js';
import { isObject, isString, toString } from 'lodash';

const secretKey = 'cNa70v4b$VFw%W+C';
const cryptoCfg = {
  mode: CryptoJS.mode.ECB,
  padding: CryptoJS.pad.Pkcs7,
};

export const aesEncrypt = (content: any, secret?: string) => {
  const srcs = isObject(content) ? JSON.stringify(content) : isString(content) ? content : toString(content);
  const key = CryptoJS.SHA256(secret || secretKey);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, cryptoCfg);
  return encrypted.toString();
};

export const aesDecrypt = (content: string, secret?: string) => {
  const key = CryptoJS.SHA256(secret || secretKey);
  const decrypt = CryptoJS.AES.decrypt(content, key, cryptoCfg);
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};
